import {isValidNumber} from 'libphonenumber-js';
import * as z from 'zod';

import {DEFAULT_NAME_REGEXP, NON_ALPHA_NUMERIC_REGEXP} from '@zoefin/constants';

export const defaultUserNameValidator = (label: string): z.ZodString =>
  z
    .string({
      error: `${label} is required`,
    })
    .min(1, {error: `${label} is required`})
    .max(30, {error: `${label} must not exceed 30 characters`})
    .regex(DEFAULT_NAME_REGEXP, {
      error: `${label} can only contain letters, spaces, hyphens, and apostrophes`,
    });

export const defaultMobileNumberValidator = (label: string): z.ZodString =>
  z
    .string({
      error: `${label} is required`,
    })
    .refine(
      (v) => {
        const invalidNumber =
          v?.replace(NON_ALPHA_NUMERIC_REGEXP, '').length < 10 ||
          !isValidNumber(v, 'US');

        if (invalidNumber) {
          return false;
        }

        return true;
      },
      {
        message: `${label} is invalid`,
      },
    );
